import { SELFIE_CHECK_FILTER_DISABLED, SELFIE_CHECK_FILTER_ENABLED } from '../actions/selfie-check'
import { LOGOUT_SUCCESS } from '../actions'

const defaultFilter = {
  pageSize: 15,
  business: '',
}
export function selfieCheckFilter(state = { selfieCheckFilter: defaultFilter }, action) {
  switch (action.type) {
    case SELFIE_CHECK_FILTER_ENABLED:
      return { ...state, selfieCheckFilter: action.selfieCheckFilter }
    case SELFIE_CHECK_FILTER_DISABLED:
      return { ...state, selfieCheckFilter: action.selfieCheckFilter }
    case LOGOUT_SUCCESS:
      return { ...state, selfieCheckFilter: null }
    default:
      return state
  }
}
